import React from 'react';
import styled from '@emotion/styled';

/**
 * Reusable PageContainer component that handles full-height layout
 * This eliminates the need for individual pages to calculate heights
 */
const StyledPageContainer = styled.div`
  background: white;
  border-radius: 8px;
  margin: 1rem;
  min-height: calc(100% - 2rem); /* Use full available height minus margins */
  padding-bottom: 2rem;
  position: relative;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  padding: 1.5rem;
`;

function PageContainer({ children, className }) {
  return (
    <StyledPageContainer className={className}>
      <ContentWrapper>
        {children}
      </ContentWrapper>
    </StyledPageContainer>
  );
}

export default PageContainer;
